import React from 'react'
import ProjectCard from '../UiComponents/ProjectCard';

const CompletedReview = (props) => {
    const {productList} = props;
    return (
        <div className="home-page-wrapper draft-wrapper-common">
            <div className="recent-header">
                <div className="recent-nav">
                    <h3><b>Review History:</b></h3>
                </div>
            </div>
            <div className="recent-body">
                <div className="no-product"><h2>You haven't reviewed any products yet.</h2><h4>Click on "<b>Review New Product</b>" on the left to start  🎉 </h4></div>
            </div>
        </div>
    )
}

export default CompletedReview;
